import axios from 'axios';
import { getCustomersCountUrl, tag } from '../config/SiteConfig';

export default async () => {
	// Get response.
	try {
		const res = await axios({
			method: 'post',
			url: getCustomersCountUrl,
			data: { tag, do: 'customersCount' },
			headers: {
				'Content-Type': 'application/json',
			},
		});

		// Return customersCount.
		return res.data[tag];
	} catch (err) {
		// console.log('err', err);
	}
};
